export interface CommentColorOption {
  key: string
  label: string
  color: string
  backgroundColor: string
}

export interface ColorPaletteOption {
  value: string
  label: string
}

export const commentColorOptions: CommentColorOption[] = [
  {
    key: 'sticky-note',
    label: 'Notiz',
    color: '#000000',
    backgroundColor: '#FEFFC6',
  },
  {
    key: 'blue',
    label: 'Blau (Decke)',
    color: '#2513FF',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'blue-tensile-connector',
    label: 'Blau (Zugverbinder)',
    color: '#0000FF',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'green',
    label: 'Grün',
    color: '#008000',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'red',
    label: 'Rot',
    color: '#FF0000',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'orange-rib',
    label: 'Orange (Rippe)',
    color: '#FF9540',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'orange',
    label: 'Orange',
    color: '#FF8001',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'cyan',
    label: 'Cyan',
    color: '#00FDFF',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'magenta',
    label: 'Magenta (Unterzug)',
    color: '#FF00FF',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'green-stiffening',
    label: 'Grün (Aussteif. Segment)',
    color: '#378436',
    backgroundColor: '#B8E2B6',
  },
  {
    key: 'gray',
    label: 'Grau (Wand)',
    color: '#999999',
    backgroundColor: '#FFFFFF',
  },
  {
    key: 'black',
    label: 'Schwarz',
    color: '#000000',
    backgroundColor: '#FFFFFF',
  },
]

export const commentPaletteColors: string[] = Array.from(
  new Set(commentColorOptions.flatMap(option => [option.color, option.backgroundColor])),
)

export const commentPaletteColorOptions: ColorPaletteOption[] = []

const excludedColorValues = new Set(['#FFFFFF'])
const normalizeHex = (value: string): string => value.toUpperCase()
const blackHex = '#000000'
const blackLabel = commentColorOptions.find(option => option.key === 'black')?.label || 'Schwarz'

for (const option of commentColorOptions) {
  const paletteCandidates = [option.color, option.backgroundColor]

  for (const candidate of paletteCandidates) {
    const normalized = normalizeHex(candidate)
    if (excludedColorValues.has(normalized)) {
      continue
    }

    if (!commentPaletteColorOptions.some(item => normalizeHex(item.value) === normalized)) {
      commentPaletteColorOptions.push({
        value: candidate,
        label: option.label,
      })
    }
  }
}

const blackOption = commentPaletteColorOptions.find(
  option => normalizeHex(option.value) === blackHex,
)
if (blackOption) {
  blackOption.label = blackLabel
}
